import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Modal, Button ,Spinner } from 'react-bootstrap';
import { api_url } from "../../constant/constant";
import { useTranslation } from 'react-i18next';
import './AddQuestion.css';
import { showToast } from '../ShowToast/ToastNotification';
import { Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const Question = ({ parentfetchQuestion }) => {
  const navigate = useNavigate();
  const location = useLocation();
      const [isLoading, setIsLoading] = useState(false); // Loader state
  
  const searchParams = new URLSearchParams(location.search);
  const lesson_id = searchParams.get("lesson_id");
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const [formData, setFormData] = useState({
    question_en: "",
    question_ar: "",
    lesson_id: ""
  });
  useEffect(() => {
    if (lesson_id) {
      setFormData(prev => ({
        ...prev,
        lesson_id: lesson_id
      }));
    }
  }, [lesson_id]);
  const [arabicError, setArabicError] = useState("");

    const handleArabicChange = (e) => {
        const { name, value } = e.target;
        // Allow Arabic letters, Arabic/English numbers, and spaces
        const arabicAndNumbersRegex = /^[\u0600-\u06FF0-9\s]+$/;
    
        if (value === "" || arabicAndNumbersRegex.test(value)) {
          setFormData({ ...formData, [name]: value });
          setArabicError(""); // Clear error
        } else {
          setArabicError(t("Please type in Arabic letters or numbers only."));
        }
      };
  const [formErrors, setFormErrors] = useState({
    question_en: "",
    question_ar: ""
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Check for special characters (RegEx allows only letters, numbers, and spaces)
    const specialCharPattern = /^[a-zA-Z0-9 ]*$/;
  
    if (name === "question_en" && !specialCharPattern.test(value)) {
      setFormErrors(prev => ({ ...prev, question_en: "Special characters are not allowed." }));
    } else {
      setFormErrors(prev => ({ ...prev, question_en: "" }));
    }
  
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  

  const handleAddQuestion = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Loader start
  
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/lessons/${lesson_id}/questions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
        redirect: "follow",
      });
  
      const data = await response.json();
  
      if (response.ok) {
        showToast(t("questionAddedSuccessfully"), "success");
        handleClose();
        setFormData({
          question_en: "",
          question_ar: "",
          lesson_id: lesson_id,
        });
        navigate(-1);
      } else if (data?.errors) {
        // Extract and show all error messages
        Object.values(data.errors).flat().forEach(error => {
          showToast(error, "error");
        });
        handleClose();
      } else {
        showToast(t("failedToAddQuestion"), "error");
        handleClose();
      }
    } catch (error) {
      showToast(t("somethingWentWrong"), "error");
      handleClose();
    } finally {
      setIsLoading(false); // Loader stop
    }
  };
  


  return (

    <div style={{ border: "1px solid #EAEAEA", borderRadius: "10px", padding: "26px 26px", marginLeft: "19px", marginTop: "20px" }}>
        <div className="d-flex justify-content-end mb-3">
                       <Button variant="primary" onClick={() => navigate(-1)} >{t('Back')}</Button>
                   </div>

      <Tabs defaultActiveKey="addEmail" className="mb-3">
        <Tab eventKey="addEmail" title={t("AddQuestion")}>

          <form onSubmit={handleAddQuestion}>
            <Modal.Body>
              {/* <div className="mb-3">
            <label className="form-label">Lesson ID</label>
            <input
              type="text"
              name="lesson_id"
              className="form-control"
              onChange={handleChange}
              value={formData.lesson_id}
            />
          </div> */}
              <div className="mb-3">
            <label className="form-label">{t('Question(English)')}</label>
            <input
              type="text"
              name="question_en"
              className={`form-control ${formErrors.question_en ? 'is-invalid' : ''}`}
              onChange={handleChange}
              value={formData.question_en}
            />
            {formErrors.question_en && (
              <div className="invalid-feedback">
                {formErrors.question_en}
              </div>
            )}
          </div>

              <div className="mb-3">
              <label className="form-label">{t("Question(Arabic)")}</label>
                                <input
                                    type="text"
                                    name="question_ar"
                                    className="form-control"
                                    value={formData.question_ar}
                                    onChange={handleArabicChange}
                                    required
                                />
                                {arabicError && (
                                    <div className="text-danger mt-1" style={{ fontSize: "0.9em" }}>
                                    {arabicError}
                                    </div>
                                )}
              </div>

            </Modal.Body>

            <Modal.Footer>
              {/* <Button variant="secondary" onClick={handleClose}>
              {t('Close')}
            </Button> */}
           <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                               {isLoading ? (
                                                   <>
                                                       <Spinner animation="border" size="sm" role="status" className="me-2" />
                                                       {t('Adding...')}
                                                   </>
                                               ) : (
                                                   t('AddQuestion')
                                               )}
                                           </button>
            </Modal.Footer>
          </form>
        </Tab>
      </Tabs>
    </div>
  );
};

export default Question;
